export const CHANNEL_PARTNER_ACCOUNT_TYPE = 'channel_partner'
export const CORPORATE_ENTERPRISE_ACCOUNT_TYPE = 'corporate_enterprise'
export const CORPORATE_PRE_ENTERPRISE_ACCOUNT_TYPE = 'corporate_pre_enterprise'
export const LEARNING_ACCOUNT_TYPE = 'learning'
export const NON_PROFIT_ACCOUNT_TYPE = 'non_profit'
export const MARKETING_ACCOUNT_TYPE = 'marketing'
export const TRAINING_PARTNER_ACCOUNT_TYPE = 'training_partner'
